import React, { Component } from "react";
import "../style/MobilePdfConsole.css";
class MobilePdfConsole extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    var is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return (
      <div
        className={`mobile-pdf-console ${
          is_safari ? "mobile-pdf-console--safari" : ""
        }`}
      >
        {this.props.children}
      </div>
    );
  }
}

export default MobilePdfConsole;



// WEBPACK FOOTER //
// ./src/components/MobilePdfConsole.js